/** @jsxImportSource @emotion/react */
import { css, TextField, Theme, InputAdornment } from "@mui/material"
import { withMyTheme } from "../../theme/theme"

const InputStyle = withMyTheme((theme: Theme, additionalCss: any) => css`
    width: 100%;
    
    & .MuiInputLabel-root {
        font-family: ${theme.typography.body1.fontFamily};
        color: ${theme.palette.text.primary};
        font-size: 1rem;
        
        &.Mui-focused {
            color: ${theme.palette.primary.main};
        }
        
        @media (min-width: 768px) {
            font-size: 1.4rem;
        }
    }

    .MuiInputLabel-root {
        background: white;
        padding: 0 6px;     
    }
    
    & .MuiOutlinedInput-root {
        border-radius: 12px;
        background-color: white;
        
        &:hover .MuiOutlinedInput-notchedOutline {
            border-color: ${theme.palette.primary.main};
        }
        
        &.Mui-focused .MuiOutlinedInput-notchedOutline {
            border-color: ${theme.palette.primary.main};
            border-width: 2px;
        }
    }
    
    & .MuiInputBase-input {
        font-family: ${theme.typography.body1.fontFamily};
        font-size: 1rem;
        padding: 14px 16px;
        
        @media (min-width: 768px) {
            font-size: 1.4rem;
            padding: 20px 24px;
        }
    }
    
    ${additionalCss ? additionalCss(theme) : ''};
`)

interface Props {
    value: string
    label?: string
    placeholder?: string
    onChange: (value: string) => void
    onBlur?: () => void
    multiline?: boolean
    rows?: number
    error?: boolean
    helperText?: string | false
    additionalCss?: any
    InputProps?: any
    InputLabelProps?: any
}

export const MyInput = ({ 
    value, 
    label, 
    onChange, 
    onBlur,
    multiline, 
    placeholder, 
    rows, 
    error,
    helperText,
    additionalCss,
    InputProps,
    InputLabelProps
}: Props) => {
    return <TextField
        value={value}
        variant="outlined"
        label={label}
        placeholder={placeholder}
        multiline={multiline}
        rows={rows}
        onChange={event => onChange(event.target.value)}
        onBlur={onBlur}
        error={error}
        InputProps={InputProps}
        InputLabelProps={InputLabelProps}
        sx={(theme) => ({
            '& .MuiInputLabel-shrink': {
                backgroundColor: theme.palette.background.paper,
                padding: '0 4px',
            },
        })}
        helperText={helperText}
        css={(theme) => InputStyle(theme, additionalCss)}
    />
}